{
  "userSelect": {
    "placeholder": "Benutzer auswählen",
    "loading": "Lädt...",
    "noUsers": "Keine Benutzer gefunden",
    "error": "Fehler beim Laden der Benutzer",
    "search": "Benutzer suchen...",
    "noResults": "Keine Benutzer gefunden.",
    "allDepartments": "Alle Abteilungen",
    "usersSelected": "{{count}} Benutzer ausgewählt",
    "usersSelected_one": "{{count}} Benutzer ausgewählt",
    "usersSelected_other": "{{count}} Benutzer ausgewählt",
    "noManager": "Kein Manager",
    "default": "Standard"
  },
  "departmentSelect": {
    "placeholder": "Abteilung auswählen",
    "loading": "Lädt...",
    "noDepartments": "Keine Abteilungen gefunden",
    "error": "Fehler beim Laden der Abteilungen",
    "search": "Abteilungen suchen...",
    "noResults": "Keine Abteilungen gefunden.",
    "allDepartments": "Alle Abteilungen",
    "noParentDepartment": "Keine übergeordnete Abteilung"
  },
  "orgFunctionSelect": {
    "placeholder": "Funktion auswählen",
    "loading": "Lädt...",
    "noOrgFunctions": "Keine Funktionen gefunden",
    "error": "Fehler beim Laden der Funktionen",
    "search": "Funktionen suchen...",
    "noResults": "Keine Funktionen gefunden.",
    "noOrgFunction": "Keine Funktion"
  },
  "systemSelect": {
    "placeholder": "System auswählen",
    "loading": "Lädt...",
    "noSystems": "Keine Systeme gefunden",
    "error": "Fehler beim Laden der Systeme",
    "search": "Systeme suchen...",
    "noResults": "Keine Systeme gefunden.",
    "noSystem": "Kein System",
    "systemsSelected": "{{count}} ausgewählt"
  },
  "userTransferListbox": {
    "error": "Fehler beim Laden der Benutzer",
    "noUsers": "Keine Benutzer verfügbar",
    "availableUsers": "Verfügbare Personen",
    "selectedUsers": "Ausgewählte Personen",
    "searchUsers": "Personen suchen…"
  },
  "surveyDialog": {
    "title": "Feedback zum Prozessschritt",
    "description": "Dein Feedback hilft, um Prozesse zu verbessern. Bitte erzähle uns, wie du den Prozessschritt empfindest.",
    "ratingQuestion": "Wie gut funktioniert dieser Schritt für dich?",
    "commentPlaceholder": "Teile deine Gedanken zu diesem Prozessschritt mit...",
    "frequencyQuestion": "Wie oft führen Sie diesen Prozessschritt durch?",
    "frequencyPlaceholder": "Häufigkeit auswählen",
    "timesPerDayQuestion": "Wie oft täglich?",
    "timesPerWeekQuestion": "Wie oft pro Woche?",
    "timesPerPeriodPlaceholder": "Anzahl eingeben (z.B. 5)",
    "durationQuestion": "Wie lange dauert dieser Schritt im Schnitt? (in Minuten)",
    "durationPlaceholder": "Dauer in Minuten eingeben (z.B. 30)",
    "submit": "Feedback absenden",
    "cancel": "Abbrechen",
    "recordedBy": "Aufgenommen von",
    "processStep": "Prozessschritt",
    "ratingSection": "Dein Feedback",
    "metricsSection": "Aufwand und Häufigkeit",
    "addCommentOptional": "Kommentar hinzufügen",
    "variantQuestion": "Machst du das genau so?",
    "variantSame": "Ja, genau so",
    "variantSameDescription": "Ich führe den Schritt genau so aus wie beschrieben.",
    "variantDifferent": "Ja, aber anders",
    "variantDifferentDescription": "Ich führe den Schritt aus, aber auf meine eigene Weise.",
    "variantNotPerformed": "Ich mache diesen Schritt nicht",
    "variantNotPerformedDescription": "Dieser Schritt gehört nicht zu meiner Arbeit.",
    "variantDescriptionQuestion": "Was machst du anders?",
    "variantDescriptionPlaceholder": "Beschreibe, was bei dir anders läuft...",
    "closedTitle": "Diese Umfrage ist beendet",
    "closedCompleted": "Deine Antworten wurden bereits gespeichert.",
    "closedDismissed": "Du hast angegeben, dass du diesen Schritt nicht machst.",
    "closedNotApplicable": "Zu dieser Umfrage gibt es für dich nichts zu beantworten."
  }
}
